import { render, staticRenderFns } from "./UsdtAddress.vue?vue&type=template&id=3ca96388&scoped=true&"
import script from "./UsdtAddress.vue?vue&type=script&lang=js&"
export * from "./UsdtAddress.vue?vue&type=script&lang=js&"
import style0 from "./UsdtAddress.vue?vue&type=style&index=0&id=3ca96388&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca96388",
  null
  
)

export default component.exports